import { CommonModule, DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@environments/environment';
import { ERR_MESSAGES } from '@shared/constants/messages.constants';
import { SITE_LINKS } from '@shared/constants/site-links.constants';
import { STORAGE } from '@shared/constants/storage.constants';
import { TOAST_TYPE } from '@shared/constants/toast.constants';
import { Reminder } from '@shared/models/notes-reminders/notes-reminders.model';
import { User } from '@shared/models/user/user.model';
import { TruncateStringPipe } from '@shared/pipes/truncate-string.pipe';
import { RemindersService } from '@shared/services/reminders/reminders.service';
import { StorageService } from '@shared/services/storage/storage.service';
import { ToastService } from '@shared/services/toast/toast.service';
import { buildUrl } from '@shared/utilities/common.utils';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'avenir-header-reminder',
  standalone: true,
  imports: [
    CommonModule
  ],
  providers: [
    TruncateStringPipe,
    DatePipe
  ],
  templateUrl: './header-reminder.component.html',
  styleUrl: './header-reminder.component.scss'
})
export class HeaderReminderComponent {
  private componentOnDestroy$ = new Subject<void>();
  showDrawer: boolean = false;
  isHovered: boolean[] = [];;
  user!: User;
  reminderList!: Reminder[];
  textMaxLength = 40;

  constructor(
    private remindersService: RemindersService,
    private storageService: StorageService,
    private router: Router,
    private truncateStringPipe: TruncateStringPipe,
    private datePipe: DatePipe
  ){}

  ngOnInit(){    
    this.user = JSON.parse(this.storageService.get(STORAGE.USER));
    this.getReminders();    

    this.remindersService.onUpdateHeaderReminders()
      .pipe(takeUntil(this.componentOnDestroy$)).subscribe(() => {
      this.getReminders();
    });
  }

  ngOnDestroy(){    
    this.componentOnDestroy$.next();
    this.componentOnDestroy$.complete();
  }

  getReminders(){
    this.remindersService.listReminders({      
      clientId: environment.CLIENT_ID,
      pageNumber: 1,
      pageSize: 9999,
      status: 1,
      assignUserId: this.user.userId,
      sort: 'followUpDate:desc'
    }).subscribe({
      next:(response) => {
        this.reminderList = response.reminderList;
      },
      error: (error) => {
        
      }
    })
  }

  toggleDrawer(){
    this.showDrawer = !this.showDrawer;
    if(this.showDrawer){ //to update list per showing drawer
      this.getReminders();
    }
  }

  goToCustomerReminders(customerId:string|number){
    let url = buildUrl(SITE_LINKS.CUSTOMER.NOTES, environment.CLIENT_ID, Number(customerId)) + `?tab=reminders`;
    this.router.navigateByUrl(url);
    this.showDrawer = false;
  }

  truncateString(text: string){
    if(text){
      return this.truncateStringPipe.transform(text, this.textMaxLength);
    }
    return;
  }

  onHover(isHovering: boolean, index: number) {
    this.isHovered[index] = isHovering;
  }

  formatDateToUTC(date:string){
    return this.datePipe.transform(date, 'MM/dd/yyyy', 'UTC');
  }
}
